<template>
  <div class="home">
    <div class="container py-5">
      <div class="row">
        <div class="col-12">
          <div class="card shadow">
            <div class="card-body">
              <h1 class="card-title text-center mb-4">Welcome to the .NET API Client</h1>
              <p class="card-text text-center">
                This Vue.js application is designed to interact with your Domain-Driven Design .NET API.
              </p>
              
              <div class="row mt-5">
                <div class="col-md-4 mb-4">
                  <div class="card h-100 border-primary">
                    <div class="card-body text-center">
                      <h5 class="card-title">Domain Entities</h5>
                      <p class="card-text">Browse and manage your domain entities with full CRUD operations.</p>
                      <router-link to="/entities" class="btn btn-primary">View Entities</router-link>
                    </div>
                  </div>
                </div>
                
                <div class="col-md-4 mb-4">
                  <div class="card h-100 border-success">
                    <div class="card-body text-center">
                      <h5 class="card-title">CQRS Commands</h5>
                      <p class="card-text">Execute commands to modify your domain state.</p>
                      <router-link to="/commands" class="btn btn-success">Run Commands</router-link>
                    </div>
                  </div>
                </div>
                
                <div class="col-md-4 mb-4">
                  <div class="card h-100 border-info">
                    <div class="card-body text-center">
                      <h5 class="card-title">CQRS Queries</h5>
                      <p class="card-text">Run queries to retrieve data from your domain.</p>
                      <router-link to="/queries" class="btn btn-info">Execute Queries</router-link>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="row mt-4">
                <div class="col-md-6 offset-md-3">
                  <div class="card border-secondary">
                    <div class="card-body text-center">
                      <h5 class="card-title">Logs</h5>
                      <p class="card-text">View structured logs from your application using Seq.</p>
                      <a href="http://localhost:8081" target="_blank" class="btn btn-secondary">Open Seq Dashboard</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeView'
}
</script>

<style scoped>
.card {
  transition: transform 0.3s;
}
.card:hover {
  transform: translateY(-5px);
}
</style>
